import React, { Component } from 'react';
import { IReducerState } from '../states/renditionStates';
import { connect } from 'react-redux';
import commonStore from '../store/commonStore.js';
import * as commonStateAction from '../actions/commonStateAction';
import $ from 'jquery';
import InfoPane from './rightPartRelated/infoPane';
import OffCuffRightPane from "../sidepart/offcuffTab/OffCuffRightPane";
import { enterKeyPressed } from '../utils/general/enterKey';

// Important!!! this is rigth Menu-Part-Template don't use old rendition DOM logic and structure. So have some style change in overview.scss

interface IRightPartTemplateProps {
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
    imageSizeCategory: string;
    collapsed: boolean;
    updateHealthWarningWidth: number;
    showOldBranding: boolean;
    analystSubscriptionData: any;
}

export class RightPartTemplate extends Component<IRightPartTemplateProps, any> {
    public _sliderEl: any;
    public _rightPaneFloatEl: any;
    public _rightPaneEl: any;
    public _mainDivEl: any;
    public _rightMarginVal: any;

    constructor(props: any) {
        super(props);
    }

    public toggleRightPane() {
        const _window: any = $(window);
        const rightPaneLeft = _window.width() - this._mainDivEl.offset()?.left - this._mainDivEl.outerWidth();

        if (this.props.collapsed) {
            this._rightPaneEl.removeClass('slideOutRight');
            this._rightPaneEl.addClass('slideInRight');
            setTimeout(() => {
                $('#health_warning').css({
                    'margin-right': rightPaneLeft + this._rightPaneEl.width()
                });
            }, 500);
            this._rightPaneFloatEl.css({
                'width': 340
            });
        } else {
            this._rightPaneEl.removeClass('slideInRight');
            this._rightPaneEl.addClass('slideOutRight');
            setTimeout(() => {
                $('#health_warning').css({
                    'margin-right': rightPaneLeft
                });
                this._rightPaneFloatEl.css({
                    'width': 20
                });
            }, 500);
        }

        // Important!!! Because collapsed use in adjustViewport(). For sync setState collapsed. So must add setTimeout in here!!
        setTimeout(() => {
            commonStore.dispatch(commonStateAction.showRightPaneState(!this.props.collapsed));
            this.adjustViewport();
            this.adjustBackToTopPosition();
        });

    }

    public reSetDisclosuresPart(rightPaneFloatElWidth: any) {
        const _window: any = $(window);
        let rightPaneLeft = _window.width() - this._mainDivEl.offset().left - this._mainDivEl.outerWidth();
        rightPaneLeft = Math.min(this._mainDivEl.offset().left, rightPaneLeft);
        this._rightMarginVal = rightPaneLeft + rightPaneFloatElWidth;

        $('#health_warning.float_disclosure').css({
            'margin-right': this._rightMarginVal + 1
        });

        const iframeDisclosure = $('div#disclosures.row .rendition-iframe-holder .iframe-disclosure');
        if (!!iframeDisclosure) {
            const iframeDisclosureBodyOuterHeight = $('div#disclosures.row .rendition-iframe-holder .iframe-disclosure').contents().find('html>body').outerHeight();
            if (!!iframeDisclosureBodyOuterHeight) {
                iframeDisclosure.css('height', iframeDisclosureBodyOuterHeight);
            }
        }
    }

    public adjustViewport() {
        const holderEl = $('#mainPage:visible,.inner-page:visible');
        const _window: any = $(window);
        const rightPaneFloatElWidth = this._rightPaneEl.width();
        if (holderEl.length) {
            if (this.props.collapsed) {
                setTimeout(() => {
                    this.reSetDisclosuresPart(0);
                }, 100);
            } else {
                setTimeout(() => {
                    this.reSetDisclosuresPart(rightPaneFloatElWidth);
                }, 500);
            }
        }

        this._rightPaneFloatEl.height(_window.height() - 60); // 60 is rsch_banner height

        const bodyJQ = $('body');
        const { imageSizeCategory } = this.props;
        setTimeout(() => {
            if ((this._sliderEl.is(':visible') && $('#slider').hasClass('collapsed')) || window.HTML_RENDITION.initialData.isStaticHtml)
                bodyJQ.addClass('slider-collapsed');
            else
                bodyJQ.removeClass('slider-collapsed');

            // Need to show scroll bar for larger screens after resize
            if (imageSizeCategory == "extraLargeScreen"
                || imageSizeCategory == "largeScreen"
                || imageSizeCategory == "mediumScreen") {
                bodyJQ.css('overflow', 'auto');
            }
        });
    }

    public adjustBackToTopPosition() {
        const backToTop = $('#back-to-top');
        const windowWidth: any = $(window).width();
        const containerWidth: any = $('.container').width();
        const rightSideClearance: any = $('#slider').hasClass('collapsed') ? 0 : this._rightPaneFloatEl.width();
        if (windowWidth > containerWidth) {
            const adjustment = (windowWidth - containerWidth) / 2;
            const right = rightSideClearance + adjustment;
            backToTop.css({ 'right': right });
        }
        else {
            backToTop.css({ 'right': '' });
        }
    }

    public componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.updateHealthWarningWidth !== this.props.updateHealthWarningWidth) {
            this.adjustViewport();
        }
    }

    public componentDidMount() {
        this._sliderEl = $('#slider');
        this._rightPaneFloatEl = $('#rightPaneFloat');
        this._rightPaneEl = $('#rightPane');
        this._mainDivEl = $('#mainDiv');
        this.adjustViewport();
        this.adjustBackToTopPosition();
        $(window).on('resize', () => {
            this.adjustViewport();
            this.adjustBackToTopPosition();
        });
    }

    public render() {
        const { docHeaderSectionJson, collapsed, showOldBranding, analystSubscriptionData } = this.props;
        return (
            <React.Fragment>
                {!window.HTML_RENDITION.initialData.isStaticHtml &&
                <div id="rightPaneFloat">
                    <div aria-label="Toggle Sidebar" role="button" tabIndex={0} id="slider"
                         title={collapsed ? docHeaderSectionJson.i18n.expand : docHeaderSectionJson.i18n.collapse}
                         aria-expanded={collapsed ? false : true}
                         className={"hidden-xs icon-sprite " + (collapsed ? "collapsed" : "")}
                         onClick={() => this.toggleRightPane()}
                         onKeyPress={(e) => enterKeyPressed(e, this.toggleRightPane.bind(this))}
                    >
                        <div id="slider-arrow"
                         className={collapsed ? "collapsed" : ""}></div>
                    </div>
                    <div id="rightPane" className="animated faster">
                        <div className="infoPane pane">
                            {!window.HTML_RENDITION.isOffCuffList && <InfoPane showOldBranding={showOldBranding} analystSubscriptionData={analystSubscriptionData}/>}

                            {window.HTML_RENDITION.isOffCuffList &&
                                <OffCuffRightPane showOldBranding={showOldBranding} />
                            }
                        </div>
                    </div>
                </div>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        imageSizeCategory: state.commonStateReducer.imageSizeCategory,
        collapsed: state.commonStateReducer.collapsed,
        updateHealthWarningWidth: state.commonStateReducer.updateHealthWarningWidth,
        analystSubscriptionData: state.asyncStateReducer.analystSubscriptionData,
    };
};

export default connect(mapStateToProps)(RightPartTemplate);
